export default __webpack_public_path__ + "static/media/p-1.9717e990.png";